import { render, staticRenderFns } from "./CheckIcon.vue?vue&type=template&id=71a39453&"
import script from "./CheckIcon.vue?vue&type=script&lang=js&"
export * from "./CheckIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports